import CreateIcon from '@mui/icons-material/Create'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import IconButton from '@mui/material/IconButton'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import * as React from 'react'
import { RecordArchiveDialog } from '../../../../dialogs/RecordArchiveDialog'
import { RecordDeleteDialog } from '../../../../dialogs/RecordDeleteDialog/RecordDeleteDialog'
import { RecordRenameDialog } from '../../../../dialogs/RecordRenameDialog/RecordRenameDialog'
import { useAssistantAdministrationStore } from '../../../../store/storeAssistantAdministration'

export const RecordItemMenu = ({ record, isList = false }) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const [openRemoveDialog, setOpenRemoveDialog] = React.useState<boolean>(false)
    const [openArchiveDialog, setOpenArchiveDialog] = React.useState<boolean>(false)
    const [openRenameDialog, setOpenRenameDialog] = React.useState<boolean>(false)

    const open = Boolean(anchorEl)
    const { setIdActiveEditRecord } = useAssistantAdministrationStore((state) => state)

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setIdActiveEditRecord(undefined)
        setOpenRemoveDialog(false)
        setOpenArchiveDialog(false)
        setOpenRenameDialog(false)
        setAnchorEl(null)
    }

    const handleClickOpenRemoveDialog = () => {
        setOpenRemoveDialog(true)
    }

    const handleClickOpenArchiveDialog = () => {
        setOpenArchiveDialog(true)
    }

    const handleClickRename = () => {
        setOpenRenameDialog(true)
    }
    const iconButtonStyle = isList
        ? { position: 'absolute', bottom: '26px', right: '6px', p: '4px' }
        : {}
    return (
        <>
            <IconButton
                sx={{
                    '&:hover': { borderColor: '#F4F4F6' },
                    ...iconButtonStyle,
                    zIndex: 1000,
                }}
                variant="text"
                color="primary"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
            {record && (
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}>
                    {!record.is_archived && (
                        <MenuItem
                            onClick={() => handleClickRename({ id: record.id })}
                            sx={{ width: '260px' }}>
                            <ListItemText
                                primary={<Typography variant="body">Переименовать</Typography>}
                            />

                            <CreateIcon fontSize="small" sx={{ marginRight: 'auto' }} />
                        </MenuItem>
                    )}

                    <MenuItem onClick={handleClickOpenArchiveDialog}>
                        <ListItemText
                            primary={
                                <Typography variant="body">
                                    {record.is_archived ? 'Разархивировать' : 'Архивировать'}
                                </Typography>
                            }
                        />
                        <Inventory2OutlinedIcon fontSize="small" />
                    </MenuItem>

                    <MenuItem onClick={handleClickOpenRemoveDialog}>
                        <ListItemText
                            primary={
                                <Typography variant="body" style={{ color: '#CA1616' }}>
                                    Удалить
                                </Typography>
                            }
                        />
                        <DeleteOutlinedIcon fontSize="small" style={{ color: '#CA1616' }} />
                    </MenuItem>
                </Menu>
            )}

            {openArchiveDialog && record && (
                <RecordArchiveDialog
                    isList={isList}
                    open={openArchiveDialog}
                    handleClose={handleClose}
                    record={record}
                />
            )}
            {openRemoveDialog && record && (
                <RecordDeleteDialog
                    open={openRemoveDialog}
                    handleClose={handleClose}
                    id={record.id}
                />
            )}
            {openRenameDialog && record && (
                <RecordRenameDialog
                    open={openRenameDialog}
                    handleClose={handleClose}
                    record={record}
                />
            )}
        </>
    )
}
